import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {getOrder, getProfile} from '/redux/action/client.action';
import {
  hasOrderById,
  hasProfileById,
  orderCustomerIdById,
  orderIsLoadingStateValue,
  orderNumberById,
} from '/redux/selector/client.selector';
import {withProps} from '/util/selector.util';

import OrderDetail from './OrderDetail';

const withCustomerClientId = withProps({clientId: orderCustomerIdById});

export default connect(
  createStructuredSelector({
    hasOrder: hasOrderById,
    hasCustomer: withCustomerClientId(hasProfileById),
    customerId: orderCustomerIdById,
    isLoading: orderIsLoadingStateValue,
    orderNumber: orderNumberById,
  }),
  dispatch => ({
    // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
    getOrder: ({orderId}: any) => dispatch(getOrder({orderId})),
    // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
    getProfile: ({clientId}: any) => dispatch(getProfile({clientId})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    hasData: stateProps.hasOrder && stateProps.hasCustomer,
    // @ts-expect-error TS(7030): Not all code paths return a value.
    fetchData: () => {
      const {hasOrder, hasCustomer, customerId, isLoading} = stateProps;
      const {orderId} = ownProps;

      if (!isLoading && orderId) {
        if (!hasOrder) {
          return dispatchProps.getOrder({orderId});
        }

        if (!hasCustomer) {
          return dispatchProps.getProfile({clientId: customerId});
        }
      }
    },
  }),
)(OrderDetail);
